import React, { useState, useEffect } from "react";
import { useUserAuth } from "../hooks/UserAuthContext";
import { toast } from "react-toastify";

export function MeetingDetailsScreen({
  onClickJoin,
  participantName,
}) {
  const [bookingIdError, setBookingError] = useState(false);
  const { bookingId, setBookingId, bookingDetails, fetchBookingDetails } = useUserAuth();

  // Function to check if meeting has ended
  const isMeetingEnded = (bookingDetails) => {
    if (!bookingDetails || !bookingDetails.endTime) return false;
    const now = new Date();
    const endTime = new Date(bookingDetails.endTime);
    return now > endTime;
  };

  // Function to check if meeting hasn't started yet
  const isMeetingNotStarted = (bookingDetails) => {
    if (!bookingDetails || !bookingDetails.startTime) return false;
    const now = new Date();
    const startTime = new Date(bookingDetails.startTime);
    return now < startTime;
  };

  // Auto-fill booking ID from session storage on component mount
  useEffect(() => {
    const sessionBookingId = sessionStorage.getItem("booking_id");
    if (sessionBookingId && !bookingId) {
      setBookingId(sessionBookingId);
    }
  }, [bookingId, setBookingId]);

  return (
    <div
      className={`flex flex-1 flex-col justify-center w-full md:p-[6px] sm:p-1 p-1.5`}
    >
      <input
        value={bookingId || ""}
        onChange={(e) => {
          setBookingId(e.target.value);
        }}
        placeholder={"Enter Booking Id"}
        className="px-4 py-3 bg-white border border-violet-400 rounded-xl text-violet-900 w-full text-center placeholder-violet-600 focus:outline-none focus:ring-2 focus:ring-violet-300 focus:border-transparent"
      />
      {bookingIdError && (
        <p className="text-xs text-white mt-1">{`Please enter valid bookingId`}</p>
      )}

      <button
        disabled={participantName.length < 3}
        className={`w-full ${participantName.length < 3
          ? "bg-gray-200 text-gray-400 cursor-not-allowed"
          : "bg-violet-600 hover:bg-violet-700 text-white"
          } px-2 py-3 rounded-xl mt-5 transition-colors duration-150 font-medium`}
        onClick={async (e) => {
          if (bookingId.match("\\w{4}\\-\\w{4}\\-\\w{4}")) {
            // Fetch booking details to check meeting time
            try {
              const details = await fetchBookingDetails(bookingId);
              
              if (details) {
                // Check if meeting hasn't started yet
                if (isMeetingNotStarted(details)) {
                  toast.error("Meeting hasn't started yet. Please wait until the scheduled time.", {
                    position: "bottom-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                  });
                  return;
                }
                
                // Check if meeting has ended
                if (isMeetingEnded(details)) {
                  toast.error("Meeting has ended", {
                    position: "bottom-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                  });
                  return;
                }
              }
              
              onClickJoin(bookingId);
            } catch (error) {
              console.error("Error checking meeting details:", error);
              onClickJoin(bookingId); // Continue with join if check fails
            }
          } else {
            setBookingError(true);
          }
        }}
      >
        Join a meeting
      </button>
    </div>
  );
}
